import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

firebase.initializeApp({
  // Prod
  apiKey: process.env.REACT_APP_FIREBASE_API,
  authDomain: 'btm-dashboard-5a1e2.firebaseapp.com',
  projectId: 'btm-dashboard-5a1e2',
  storageBucket: 'btm-dashboard-5a1e2.appspot.com',
  messagingSenderId: '585854034004',
  appId: '1:585854034004:web:02e0a474492ebdb0328dc1',
  measurementId: 'G-J5TMZYSV7L'

  // Test
  // apiKey: "AIzaSyCAYke8CwqGpAjLFfDLh_ZvNuFuau-iuNY",
  // authDomain: "behind-the-markets.firebaseapp.com",
  // projectId: "behind-the-markets",
  // storageBucket: "behind-the-markets.firebasestorage.app",
  // messagingSenderId: "152968134612",
  // appId: "1:152968134612:web:a28de52b1a026ea5382041",
  // measurementId: "G-T96J7QMQZB"
});

export const auth = firebase.auth()
export const firestore = firebase.firestore()
export const db = firebase